"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Vehiclesummary = /** @class */ (function () {
    function Vehiclesummary(component) {
        this.component = component;
        this.config = {};
        this.loadConfig();
        this.updateTransactionId();
        this.saveConfig();
    }
    Vehiclesummary.prototype.loadConfig = function () {
        var configData = this.component.dataset.config;
        if (configData) {
            this.config = JSON.parse(configData);
        }
    };
    Vehiclesummary.prototype.updateTransactionId = function () {
        var transactionId = new URLSearchParams(window.location.search).get('ncbp_transaction-id');
        if (transactionId) {
            this.config.transactionId = transactionId;
        }
    };
    Vehiclesummary.prototype.saveConfig = function () {
        this.component.setAttribute('data-config', JSON.stringify(this.config));
    };
    return Vehiclesummary;
}());
exports.default = Vehiclesummary;
document.addEventListener('DOMContentLoaded', function () {
    var vehicleSummaryElement = document.querySelector('div.js-vehicle-summary[data-config]');
    if (vehicleSummaryElement) {
        try {
            new Vehiclesummary(vehicleSummaryElement);
        }
        catch (error) {
            console.error('Error while creating a new VehicleSummary instance:', error);
        }
    }
});
